<template>
    <div style="height: 300px; position: relative">
        <template v-if="loading">
            <div class="fill-height d-flex align-center justify-center">
                <app-centre-loader label="Loading Team Team App Usage"></app-centre-loader>
            </div>
        </template>
        <template v-else>
            <div style="position: relative">
                <div
                        class="text-center text-h6 font-weight-thin"
                        style="position: absolute; left: 0; top: 0; width: 100%"
                >
                    Team App Usage Last 7 Days
                </div>
<!--                <apex-chart height="300" type="line" :options="chartOptions"-->
<!--                            :series="chartData.series"></apex-chart>-->
            </div>
        </template>

    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {durationDisplay, hourDisplayWithoutUnit} from "@/core/codeFunctions";
import AppIcon from "@/components/Shared/AppIcon";
import {mapActions} from "vuex";
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
export default {
    components: {
        AppCentreLoader,
        AppIcon,
        apexChart: VueApexCharts,
    },
    props: {
        propName: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: true,
            stats: [],
            gradient: ["var(--v-primary-lighten1)", "var(--v-primary-darken2)"],
            refreshInterval: null,
            hourDisplayWithoutUnit
        }
    },
    mounted() {
        this.loadProductivity();
        this.refreshInterval = setInterval(() => {
            this.loadProductivity()
        }, 60000)
    },
    beforeDestroy() {
        clearInterval(this.refreshInterval)
    },
    methods: {
        ...mapActions(['gotoAppStats']),
        async loadProductivity() {
            try {
                this.stats = await this.$newReq('GET', 'dashboard/stats/teamAppUsageLast7Days')
                this.loading = false
            } catch (e) {
                console.log(e)
            }
        }
    },
    computed: {
        labels() {return this.stats.map(stat => stat.key)},
        series() {
            const total = this.stats.reduce((val, item) => {
                return val + item.value
            }, 0)
            return this.stats.map(stat => stat.value/total * 100)
        },

        chartData() {
            const teams = this.stats.reduce((list, item) => list.includes(item.teamName) ? list : list.concat(item.teamName), [])
            const timeNames = [];
            const min = this.stats.reduce((val, item) => val === null || item.bs < val ? item.bs : val, null)
            const max = this.stats.reduce((val, item) => val === null || item.bs > val ? item.bs : val , null)
            const seriesData = {}
            teams.forEach(teamName => {
                seriesData[teamName] = {
                    name: teamName,
                    data: []
                }
            })
            for (let k = min; k <= max; k = k + 900 ) {
                timeNames.push(`${(Math.floor(k / 3600) + 2).toString().padStart(2, '0')}:${Math.floor((k % 3600) / 60).toString().padStart(2, '0')}`)
                for (const team of teams) {
                    const record = this.stats.find(obj => obj.teamName === team && obj.bs === k)
                    seriesData[team].data.push(record && record.tt ? record.tt : 0)
                }
            }

            const series = Object.values(seriesData)
            return {
                labels: timeNames,
                series
            }
        },

        chartOptions() {
            // Get A List Of Teams

            const chartOptions = {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {enabled: false},
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                grid: {
                    show: true,
                    borderColor: 'var(--v-primary-base)',
                    strokeDashArray: 0,
                    position: 'back',
                    yaxis: {
                        lines: {
                            show: false
                        }
                    },
                },
                xaxis: {
                    categories: this.chartData.labels,
                    labels: {
                        rotate: -60,
                        rotateAlways: true,
                        style: {
                            colors: this.chartData.labels.map(() => '#fff'),
                        },
                    },
                    axisBorder: {
                        show: true,
                        color: 'var(--v-primary-base)',
                        height: 1,
                    },
                },
                tooltip: {
                    enabled: false,
                    theme: 'dark',
                    y: {
                        formatter: function (val) {
                            return durationDisplay(val)
                        },
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                },
                yaxis: {
                    show: true,
                    title: {
                        text: 'Activity'
                    },
                    labels: {
                        show: false,
                    },
                },
                legend: {
                    labels: {
                        colors: ['#fff']
                    },
                },
            }

            return chartOptions
        },
    }
}
</script>

<style scoped>

.txt:hover {
    text-decoration: underline;
    color: #fff !important;
    cursor: pointer;
}

</style>